<template>
  <div class="upload-card-container">
    <!-- ElementUI 卡片式上传核心组件 -->
    <el-upload
      ref="uploadRef"
      :action="uploadApi"
      list-type="picture-card"
      :file-list="fileList"
      :limit="limit"
      :accept="accept"
      :headers="headers"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :disabled="disabled"
      :auto-upload="autoUpload"
      :show-file-list="true"
      class="upload-card"
    >
      <!-- 上传加号卡片 -->
      <div style="">
        <i class="el-icon-plus upload-icon"></i>
      </div>
    </el-upload>
    <div style="margin-top: 10px; display: flex; align-items: center">
      <i class="el-icon-warning f15"></i>
      <p style="padding-left: 10px" class="f12">
        格式支持jpg，png，单张图片大小不超过10M
      </p>
    </div>
    <!-- 大图预览弹窗 -->
    <el-dialog v-model="previewVisible" title="文件预览" width="80%">
      <img :src="previewSrc" alt="预览文件" class="preview-img" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UploadImg",
  props: {
    // 【必填】上传接口地址
    uploadUrl: {
      type: String,
      required: false,
    },
    // 【可选】上传文件时，需要传递的字段名，默认file
    prop: {
      type: String,
      default: "",
    },
    // 【可选】已上传的文件列表，回显用 格式：[{name: 'xxx.jpg', url: 'http://xxx'}]
    fileList: {
      type: Array,
      default: () => [],
    },
    // 【可选】限制上传数量，默认不限制，传数字即可（如1=单文件，5=最多5个）
    limit: {
      type: Number,
      default: 0,
    },
    // 【可选】文件格式限制 例：image/* 图片、.pdf,.doc 文档、video/* 视频
    accept: {
      type: String,
      default: "image/*",
    },
    // 【可选】文件大小限制(M)，默认2M
    fileSize: {
      type: Number,
      default: 2,
    },
    // 【可选】请求头，一般传token用 例：{Authorization: 'Bearer ' + token}
    headers: {
      type: Object,
      default: () => ({}),
    },
    // 【可选】是否禁用上传
    disabled: {
      type: Boolean,
      default: false,
    },
    // 【可选】是否自动上传，true=选完文件直接传，false=手动调用上传（表单提交常用）
    autoUpload: {
      type: Boolean,
      default: true,
    },
    // 【可选】上传文件的提示文案
    tipText: {
      type: String,
      default: "支持JPG/PNG格式，单文件不超过2M",
    },
  },
  data() {
    return {
      uploadApi: this.$uploadUrl, // 上传接口
      previewVisible: false, // 预览弹窗显隐
      previewSrc: "", // 预览文件地址
    };
  },
  methods: {
    // 上传前校验：文件格式 + 文件大小
    handleBeforeUpload(file) {
      // 1. 文件大小校验
      const isOverSize = file.size / 1024 / 1024 > this.fileSize;
      if (isOverSize) {
        this.$message.error(`文件大小不能超过 ${this.fileSize}MB!`);
        return false;
      }
      // 2. 文件格式校验（accept有值时生效）
      if (this.accept) {
        const fileName = file.name;
        const fileSuffix = fileName.substring(fileName.lastIndexOf("."));
        const acceptArr = this.accept.split(",").map((item) => item.trim());
        const isFormat = acceptArr.some((item) => {
          if (item.includes("/")) return file.type.includes(item.split("/")[0]);
          return item === fileSuffix;
        });
        if (!isFormat) {
          this.$message.error(
            `文件格式不正确，请上传${this.tipText}规定的格式!`,
          );
          return false;
        }
      }
      return true;
    },

    // 上传成功回调
    handleSuccess(res, file, fileList) {
      // 上传成功的后端返回数据，统一抛给父组件处理（重中之重）
      this.$emit("upload-success", res, file, fileList, this.prop);
      this.$message.success("文件上传成功！");
    },

    // 上传失败回调
    handleError(err, file, fileList) {
      this.$emit("upload-error", err, file, fileList);
      this.$message.error("文件上传失败，请重试！");
    },

    // 删除文件回调
    handleRemove(file, fileList) {
      // 删除事件抛给父组件，父组件同步更新已上传列表
      this.$emit("remove-file", file, fileList);
    },

    // 预览文件/图片
    handlePreview(file) {
      this.previewSrc = file.url || file.response?.data?.url;
      this.previewVisible = true;
    },

    // 暴露给父组件的方法：手动触发上传（适用于 autoUpload=false 场景）
    submitUpload() {
      this.$refs.uploadRef.submit();
    },

    // 暴露给父组件的方法：清空所有上传文件
    clearUpload() {
      this.$refs.uploadRef.clearFiles();
      this.$emit("clear-file");
    },
  },
};
</script>

<style lang="scss" scoped>
// // 覆盖element上传组件默认样式
// ::v-deep.upload-card {
//   /* 彻底隐藏 Element Upload 上传时的进度条，全局生效 */
//   .el-upload-list__item .el-progress {
//     display: none !important;
//   }
//   .el-upload.el-upload--picture-card {
//     border: 1px solid blue;
//     width: 60px !important;
//     height: 60px !important;
//     line-height: 60px !important;
//   }
//   .el-upload-list {
//     .el-upload-list__item {
//       width: 60px !important;
//       height: 60px !important;
//     }
//     .el-upload-list__item.is-success {
//       .el-upload-list__item-status-label{
//       }
//       .el-upload-list__item-actions {
//         width: 60px !important;
//         height: 60px !important;
//       }
//       .el-upload-list__item-thumbnail {
//         width: 60px !important;
//         height: 60px !important;
//       }
//     }
//   }
// }
.upload-card-container {
  width: 100%;
  box-sizing: border-box;
}

.upload-card {
  ::v-deep .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
    border-radius: 4px;
    border: 1px dashed #dcdcdc;
    &:hover {
      border-color: #409eff;
    }
  }

  ::v-deep .upload-icon {
    font-size: 28px;
    color: #c0c4cc;
  }

  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
    border-radius: 4px;
  }
}

// 预览图片样式
.preview-img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
